import { get } from "../helpers/config";
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

export const useGetFinance = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await get("finance?startDate=" + data.startDate + "&endDate=" + data.endDate + "&countryID=" + data.countryID);
    }, options);
};